export default __webpack_public_path__ + "static/media/Easter egg wreath1.ad548801.jpg";